let language = {
    "301180": "该店铺的店主不属于当前用户",
    "302106": "当前用户的电子邮件地址尚未激活",
    "302101": "安全检查失败，数据存在被篡改的风险。如果您是该店铺的所有者但该店铺未显示在您的账户中，请联系我们寻求帮助。（{{supportEmail}}）",
};

export { language }
